import React from 'react'
import { Stack } from '@hub/stack'
import { SGPageTemplate } from '../../../../src/types/page-templates'
import { Module } from './modules'

export interface ITemplateProps {
  template: SGPageTemplate
  id?: string
}

export function Template({ template, id }: ITemplateProps): JSX.Element {
  const modules = template.modules.flatMap((module, idx) => (
    <Module key={idx} module={module} />
  ))

  return (
    <>
      {modules.length ? (
        <Stack gap={['spacing-3xl', null, 'spacing-4xl']} id={id}>
          {modules}
        </Stack>
      ) : null}
    </>
  )
}
